export default __webpack_public_path__ + "static/SBT2-d131db4c6efd1e3ebc704ee4f1172d96.png";